<template>
  <div v-show="matchSearch">
    <group-row :group="group"
      :level="level"
      :showDropdown="showDropdown"
      :searchTerm="searchTerm"
      :searchMatchInChild="searchMatchInChild"
      @searchFound="searchFound"
      :pageType="pageType"
      @toggleDropdown="showDropdown = !showDropdown" />
    <template v-if="isUsersPage">
      <user-row v-for="user in group.users"
        :user="user"
        :group="{ name: group.name, id: group.id }"
        :level="level"
        :key="user.id"
        :searchTerm="searchTerm"
        @searchFound="searchFoundInChild"
        :hideForParent="!showDropdown"/>
    </template>
    <template v-else-if="isLicensesPage">
      <license-row v-for="pool in group.pools"
        :pool="pool"
        :group="{ name: group.name, id: group.id }"
        :level="level"
        :key="pool.id"
        :searchTerm="searchTerm"
        @searchFound="searchFoundInChild"
        :hideForParent="!showDropdown"/>
    </template>
    <recursive-rows :groups="group.children"
      :level="nextLevel"
      :searchTerm="searchTerm"
      @searchFound="searchFoundInChild"
      :pageType="pageType"
      v-show="showDropdown"/>
  </div>
</template>

<script>
import GroupRow from './GroupRow.vue';
import UserRow from './UserRow.vue';
import LicenseRow from './LicenseRow.vue';
import config from '../../config';

export default {
  components: {
    GroupRow,
    UserRow,
    LicenseRow
  },
  name: 'RecursiveRow',
  props: {
    group: Object,
    level: Number,
    searchTerm: String,
    pageType: String
  },
  data() {
    return {
      showDropdown: true,
      matchSearch: true,
      searchMatchInChild: false
    }
  },
  methods: {
    searchFound() {
      this.matchSearch = true;
      this.showDropdown = true;
      this.$emit('searchFound');
    },
    searchFoundInChild() {
      this.searchFound();
      this.searchMatchInChild = true;
    }
  },
  computed: {
    nextLevel() {
      return this.level + 1;
    },
    isUsersPage() {
      return this.pageType == config.USERS_PAGE;
    },
    isLicensesPage() {
      return this.pageType == config.LICENSES_PAGE;
    }
  },
  watch: {
    searchTerm(newTerm) {
      this.searchMatchInChild = false;
      if (!newTerm) {
        this.matchSearch = true;
      } else {
        this.matchSearch = false;
      }
    }
  }
};
</script>
